import { z } from 'zod'

import { aswapSchema } from '@/pages/instruments/new-instrument/schemas/aswap.schema'
import { autocallConsolationSchema } from '@/pages/instruments/new-instrument/schemas/autocall-consolation.schema'
import { autocallStandardSchema } from '@/pages/instruments/new-instrument/schemas/autocall-standard.schema'
import { bondSchema } from '@/pages/instruments/new-instrument/schemas/bond.schema'
import { digitalSchema } from '@/pages/instruments/new-instrument/schemas/digital.schema'
import { diverOtcSchema } from '@/pages/instruments/new-instrument/schemas/diver-otc.schema'
import { equityOtcSchema } from '@/pages/instruments/new-instrument/schemas/equity-otc.schema'
import { equitySchema } from '@/pages/instruments/new-instrument/schemas/equity.schema'
import { fundSchema } from '@/pages/instruments/new-instrument/schemas/fund.schema'
import { fxfwdSchema } from '@/pages/instruments/new-instrument/schemas/fxfwd.schema'
import { indexSchema } from '@/pages/instruments/new-instrument/schemas/index.schema'
import { otherSchema } from '@/pages/instruments/new-instrument/schemas/other.schema'
import { phoenixNonMemorySchema } from '@/pages/instruments/new-instrument/schemas/phoenix-non-memory.schema'
import { rangeAccrualSchema } from '@/pages/instruments/new-instrument/schemas/range-accrual.schema'
import { supertrackerSchema } from '@/pages/instruments/new-instrument/schemas/supertracker.schema'
import { vanillaDigitalSchema } from '@/pages/instruments/new-instrument/schemas/vanilla-digital.schema'
import { vanillaSpreadSchema } from '@/pages/instruments/new-instrument/schemas/vanilla-spread.schema'
import { vanillaStructuredSchema } from '@/pages/instruments/new-instrument/schemas/vanilla-structured.schema'
import { vanillaSchema } from '@/pages/instruments/new-instrument/schemas/vanilla.schema'

export const allInstrumentsSchema = z.discriminatedUnion('instrument_type', [
  bondSchema,
  equitySchema,
  indexSchema,
  aswapSchema,
  fundSchema,
  fxfwdSchema,
  diverOtcSchema,
  equityOtcSchema,
  autocallStandardSchema,
  autocallConsolationSchema,
  phoenixNonMemorySchema,
  digitalSchema,
  vanillaSpreadSchema,
  vanillaStructuredSchema,
  rangeAccrualSchema,
  supertrackerSchema,
  vanillaSchema,
  vanillaDigitalSchema,
  otherSchema,
])

export type AllInstrumentsSchemaType = z.infer<typeof allInstrumentsSchema>
